import { useEffect } from "react";
import bootstrap from "../config/bootstrap";
import config from "../config/index";

const init = bootstrap;

const Authenticate = () => {
	useEffect(() => {
		const { spaceIOService } = init();

		const initializeSpaceIoService = async () => {
			if (!spaceIOService?.initialized) {
				const response = await spaceIOService.init();
				spaceIOService.initialized = true;

				if (response === "Done") {
					window.location.href = `${config.REACT_APP_DOMAIN_REFERRER_URL}/requester`;
				}
			}
		};

		initializeSpaceIoService();
	}, []);

	return null;
};

export default Authenticate;
